import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { ApplicationTable } from "./ApplicationTable";
import ViewApplication from "./ViewApplication";
import { UserDelimitation } from "../users/UserDelimitation";
import "./Applications.css";
import { authenticationService } from "../../services/AuthenticationService";

import { AppDB } from "../../App";
import VerifyApplication from "./VerifyApplication";
import {
	APPLICATION_AWAITING_CORRECTION,
	APPLICATION_STATUS_APPROVED,
	APPLICATION_STATUS_NEW,
	APPLICATION_STATUS_PENDING,
	APPLICATION_STATUS_REFERRED,
	APPLICATION_STATUS_REJECTED,
	CHANNEL_CATEGORY_ASSISTED,
	CHANNEL_CATEGORY_UNASSISTED,
	permissionLookUp
} from "../../constants";
import { Button } from "primereact/button";
import AddObjections from "../../componets/AddObjections";
import ApplicationActionsLoader from "./ApplicationActionsLoader";
import { useIsAuthenticated } from "@azure/msal-react";
import { Dialog } from "primereact/dialog";
import MultiFilterSearch from "../../componets/MultiFilterSearch";
import AddCorrections from "./corrections/AddCorrection";
import { applicationsService } from "../../services/ApplicationsService";

export class ApplicationQuery {
	constructor(
		pageIndex = 1,
		pageSize = 10,
		applicationTypeID = "",
		applicationStatusID = "",
		delimitationID = "",
		delimitationLevelID = "",
		channelCategoryID = null,
		passedRequirements = null,
		allowNullDelimitation = false
	) {
		this.pageIndex = pageIndex;
		this.pageSize = pageSize;
		this.applicationTypeID = applicationTypeID;
		this.applicationStatusID = applicationStatusID;
		this.delimitationID = delimitationID;
		this.delimitationLevelID = delimitationLevelID;
		this.channelCategoryID = channelCategoryID;
		this.passedRequirements = passedRequirements;
		this.allowNullDelimitation = allowNullDelimitation;
	}
}

export const Applications = ({ applicationTypeID, channelCategoryID, RenderObjection = () => <></> }) => {
	const { setGlobalDelimitation, globalDelimitation, setUserInfo } = useContext(AppDB);
	const toast = useRef(null);
	const [query, setQuery] = useState(null);
	const { permission,lookUp } = useContext(AppDB);
	const [activeTabIndex, setActiveTabIndex] = useState(globalDelimitation?.activeTabIndex || 0);

	const isAuthenticated = useIsAuthenticated();

	const [application, setApplication] = useState(null);
	const [showApplication, setShowApplication] = useState(false);
	const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });
	const [canTransact, setCanTransact] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadData, setLoadData] = useState(false);
	const [refreshApplication, setRefreshApplication] = useState(false);
	const [returnedApplication,setReturnedApplication] =useState(false)
	// const [channelCategoryID, setChannelCategoryID] = useState(null);
	var { setPermission } = useContext(AppDB);
	var { currrentApplicationScreen, setOfficeOnly } = useContext(AppDB);

	var [makeDashboardTrigger, setMakeDashboardTrigger] = useState(!["", null, undefined].includes(globalDelimitation.activeTabIndex) ? true : false);

	const onHideApplication = () => {
		setShowApplication(false);
		setApplication(null);
	};

	const onShowApplication = (application) => {
		setApplication(application);
		setShowApplication(true);
	};

	const onBeforeTabChange = (e) => {
		setLoadData(false); //disable tab content refresh
		setActiveTabIndex(e.index);
	};

	var rawCorrectionsData = {
		voterID: 0,
		correctionNotes: null,
		isTransfer: false,
		isAmendment: false,
		correctionAttributeID:[],
		cellPhone1CountryCodeID:  lookUp?.countryCodes?.find(c => c.id === 65)?.id,
		cellPhone: null,
		cellPhone2CountryCodeID:  lookUp?.countryCodes?.find(c => c.id === 65)?.id,
		cellPhone2: null,
		email: null,
		firstName: null,
		middleName: null,
		surname: null,
		disabilityID: null,
		transferReasonID: null,
		fromVillageID: null,
		toVillageID: null,
		binaryData: []
	};
	const applicationMapping = {};
	var drawApplicationsTab = [
		{ screen: "amendments", tab: "Amendments", menus: ["Queued", "Returned", "Passed", "Failed", "Approved", "Rejected"] },
		{ screen: "registration", tab: "Registrations", menus: ["Queued", "Returned", "Passed", "Failed", "Approved", "Rejected"] },
		{ screen: "migration", tab: "Migrations", menus: ["Queued", "Passed", "Failed", "Approved", "Rejected"] },
		{ screen: "transfers", tab: "Transfers", menus: ["Queued", "Returned", "Pending", "Approved", "Rejected"] },
		{ screen: "removals", tab: "Removals", menus: ["Queued", "Returned", "Pending", "Approved", "Rejected"] },
		{ screen: "suspensions", tab: "Suspensions", menus: ["Queued", "Returned", "Pending", "Approved", "Rejected"] },
		{ screen: "re-instatements", tab: "Re-Instatements", menus: ["Queued", "Returned", "Passed", "Failed", "Approved", "Rejected"] },
		{ screen: "Objections", tab: "Objections", menus: ["Queued", "Pending", "Approved", "Rejected"] },
		{ screen: "corrections", tab: "Corrections", menus: ["Pending", "Approved", "Rejected"] },
		{ self: true, screen: "unassisted-registration", tab: "Self Service Checks - Registrations", menus: ["Pending", "Rejected"] },
		{ self: true, screen: "unassisted-amendments", tab: "Self Service Checks - Amendments", menus: ["Pending", "Rejected"] }
	];

	const STATUS_CONSTANTS = {
		Awaiting_Correction: APPLICATION_AWAITING_CORRECTION,
		Queued: APPLICATION_STATUS_NEW,
		Returned: APPLICATION_STATUS_REFERRED,
		Passed: APPLICATION_STATUS_PENDING,
		Failed: APPLICATION_STATUS_PENDING,
		Pending: APPLICATION_STATUS_PENDING,
		Approved: APPLICATION_STATUS_APPROVED,
		Rejected: APPLICATION_STATUS_REJECTED
	};
	function applicationStatusFilter(screenName, status) {
		if (["unassisted-registration", "unassisted-amendments"].includes(screenName)) {
			if (status == "Pending") return STATUS_CONSTANTS.Queued;
		}
		return STATUS_CONSTANTS[status];
	}

	function passedRequirementsFilter(status) {
		if (["Queued"].includes(status)) {
			return null;
		}
		if (["Pending", "Approved", "Passed"].includes(status)) {
			return true;
		}

		return false;
	}

	function permissionInfoHandler(screen, status) {
		var obj = {
			// ...permission,
			tabName: null,
			currentTab: activeTabIndex,
			Create: false,
			Read: false,
			Update: false,
			Referral: false,
			Approve: false,
			Reject: false,
			Recommend: false,
			Withdraw: false,
			RecommendButton: "Recommend"
		};
		switch (status) {
			case "Queued":
				obj.RecommendButton = "Investigation Outcome";
				if (["Objections"].includes(screen)) {
					obj.Withdraw = true;
					obj.Recommend = true;
				}
				if (screen === "corrections") {
					obj.Create = true;
				}

				break;
			case "Pending":
				if (["unassisted-registration", "unassisted-amendments", "transfers", "amendments"].includes(screen)) {
					obj.Approve = true;
					obj.Reject = true;
				}
				if (["suspensions", "removals"].includes(screen)) {
					obj.Referral = true;
					obj.Reject = true;
					obj.Approve = true;
				}
				if (["Objections"].includes(screen)) {
					obj.Recommend = true;
					obj.Reject = true;
					obj.Approve = true;
				}
				break;
			case "Returned":
				obj.Update = true;
				break;
			case "Passed":
				obj.Approve = true;

				if (["registration", "amendments"].includes(screen)) {
					obj.Referral = true;
				}
				break;
			case "Failed":
				obj.Reject = true;
				if (["registration", "amendments"].includes(screen)) {
					obj.Referral = true;
				}
				break;
			case "Approved":
				break;
			case "Rejected":
				break;
		}
		return obj;
	}

	drawApplicationsTab = drawApplicationsTab.map((tab) => ({
		...tab,
		permissionInfo: tab.menus.map((status) => permissionInfoHandler(tab.screen, status)),
		tabsInfo: tab.menus.map((status) => {
			var CHANNEL_CATEGORY = null;
			var passedRequirements = passedRequirementsFilter(status);
			if (["Queued"].includes(status)) {
				CHANNEL_CATEGORY = CHANNEL_CATEGORY_ASSISTED;
			}
			if (["Returned"].includes(status)) {
				passedRequirements = null;
			}
			if (["suspensions", "re-instatements", "removals"].includes(tab.screen)) {
				if (["Pending"].includes(status)) {
					passedRequirements = null;
				}
			}
			var obj = {
				name: status,
				pageIndex: 1,
				pageSize: 10,
				applicationTypeID: applicationTypeID,
				applicationStatusID: applicationStatusFilter(tab.screen, status),
				delimitationID: delimitation.delimitationID,
				delimitationLevelID: delimitation.delimitationLevelID,
				channelCategoryID: ["unassisted-registration", "unassisted-amendments"].includes(tab.screen) ? CHANNEL_CATEGORY_UNASSISTED : null,
				passedRequirements: ["unassisted-registration", "unassisted-amendments"].includes(tab.screen) ? null : passedRequirements,
				allowNullDelimitation: ["unassisted-registration", "unassisted-amendments"].includes(tab.screen) ? true : false
			};

			// if(tab.screen ==="corrections"){
			// 	delete obj.passedRequirements;
			// 	delete obj.channelCategoryID;
			// 	delete obj.delimitationID;
			// 	delete obj.delimitationLevelID
			// }

			if (obj.passedRequirements === null) delete obj.passedRequirements;
			if (obj.channelCategoryID === null) delete obj.channelCategoryID;
			return obj;
		})
	}));

	drawApplicationsTab.forEach(({ self, screen, menus }) => {
		applicationMapping[screen] = {};
		menus.forEach((status, index) => {
			var status = STATUS_CONSTANTS[status];
			applicationMapping[screen][index] = {
				applicationStatusID: STATUS_CONSTANTS[status],
				self: self,
				page: 10,
				passedRequirements: status === APPLICATION_STATUS_APPROVED || status === APPLICATION_STATUS_PENDING
			};
		});
	});

	function loadApplications() {
		// var res = applicationMapping[currrentApplicationScreen]?.[activeTabIndex]
		var currentScreen = drawApplicationsTab.find((tab) => tab.screen === currrentApplicationScreen);
		if (currentScreen) {
			var tabs = currentScreen.tabsInfo;
			var tabsPermission = currentScreen.permissionInfo;

			if (tabs) {
				var currentTabInfo = tabs[activeTabIndex];
				var currentTabPermission = tabsPermission[activeTabIndex];
				if (currentTabInfo) {
					const selectedStatus = currentScreen.menus[activeTabIndex];
					if (selectedStatus === "Returned") {
						setReturnedApplication(true);
					} else {
						setReturnedApplication(false);
					}

					delete currentTabInfo.name;
					setTimeout(() => {
						setPermission((prev) => ({ ...prev, ...currentTabPermission }));
					}, 200);
					setQuery({
						...currentTabInfo
					}); //New

					setLoadData(true);
					return;
				}
			}
		}
	}

	function onSubmitApplication() {
		setShowApplication(false);
		setApplication(null);
		setRefreshApplication(!refreshApplication);
	}
	useEffect(() => {
		loadApplications();
	}, [currrentApplicationScreen, delimitation, activeTabIndex, refreshApplication]);

	const [showAddObjectionForm, setShowAddObjectionForm] = useState(false);

	const [searchVoter, setSearchVoter] = useState(false);
	const [correctionsLoading, setcorrectionsLoading] = useState(false);
	const [voterData, setVoterData] = useState({});
	const [showAddCorrectionDialog, setshowAddCorrectionDialog] = useState(false);
	const submitCorrection = async (correctionData,setCorrectionData) => {
		setcorrectionsLoading(true);
		if (!correctionData.voterID) {
			toast.current?.show({
				severity: "error",
				summary: "Error",
				detail: "Voter ID is required",
				life: 3000
			});
			return;
		}
		var clonedCorrectionData={...correctionData}

		if([null,undefined,""].includes(clonedCorrectionData.cellPhone ))
		{
			clonedCorrectionData.cellPhone1CountryCodeID =null
		}
			if([null,undefined,""].includes(clonedCorrectionData.cellPhone2 ))
		{
			clonedCorrectionData.cellPhone2CountryCodeID =null
		}

		// Call your API
		await applicationsService
			.createCorrection(clonedCorrectionData)
			.then((resp) => {
				setcorrectionsLoading(false);
				if (resp?.success) {
					toast.current?.show({
						severity: "success",
						summary: "Success",
						detail: resp?.message,
						life: 3000
					});

					setshowAddCorrectionDialog(false); // close dialog
					setRefreshApplication(!refreshApplication); // refresh table
					setCorrectionData(rawCorrectionsData)
				} else {
					toast.current?.show({
						severity: "error",
						summary: "Error",
						detail: resp?.message,
						life: 3000
					});
					setLoading(false);
					setshowAddCorrectionDialog(false); // close dialog
				}
			})
			.catch((error) => {
				console.error("Error submitting correction:", error);
				toast.current?.show({
					severity: "error",
					summary: "Error",
					detail: "Failed to submit correction",
					life: 3000
				});
			});
	};

	return (
		<Card
			title={
				<>
					{currrentApplicationScreen === "registration" && "Registrations"}
					{currrentApplicationScreen === "migration" && "Migrations"}
					{currrentApplicationScreen === "transfers" && "Transfers"}
					{currrentApplicationScreen === "amendments" && "Amendments"}
					{currrentApplicationScreen === "removals" && "Removals"}
					{currrentApplicationScreen === "suspensions" && "Suspensions"}
					{currrentApplicationScreen === "re-instatements" && "Re-Instatements"}
					{currrentApplicationScreen === "corrections" && "Corrections"}
					{currrentApplicationScreen === "unassisted-registration" && "Self Service Checks - Registrations"}
					{currrentApplicationScreen === "unassisted-amendments" && "Self Service Checks - Amendments"}
				</>
			}
		>
			{/* {RenderObjection} */}
			{currrentApplicationScreen === "Objections" && (
				<>
					<div className="flex" style={{ justifyContent: "space-between", alignContent: "center" }}>
						<h4>Objections</h4>
						{/* <Button className="p-button-success mr-2"  label="Add Objection" onClick={() => setShowAddObjectionForm(true)} /> */}
					</div>
					<AddObjections
						key={showAddObjectionForm}
						loadApplications={loadApplications}
						show={showAddObjectionForm}
						setShow={setShowAddObjectionForm}
					/>
				</>
			)}

			{currrentApplicationScreen === "corrections" && (
				<>
					{permission?.actions?.includes(permissionLookUp.Create) && <Button label="Add Correction" onClick={() => setSearchVoter(true)} />}
					<Dialog visible={searchVoter} onHide={() => setSearchVoter(false)} header="Add Correction">
						<MultiFilterSearch
							label={
								<>
									<span>
										Search Voter <span style={{ color: "red" }}>*</span>
									</span>
								</>
							}
							onClear={() => {
								setVoterData({});
							}}
							onChange={(res) => {
								setVoterData(res);
								setSearchVoter(false);
								setshowAddCorrectionDialog(true);
							}}
						/>
					</Dialog>

					<AddCorrections
						voterData={voterData}
						loading={correctionsLoading}
						setLoading={setcorrectionsLoading}
						showAddcorrections={showAddCorrectionDialog}
						setShowAddCorrections={setshowAddCorrectionDialog}
						submitCorrection={submitCorrection}
						rawCorrectionsData={rawCorrectionsData}
					/>
				</>
			)}

			<Toast ref={toast} />
			{!["unassisted-registration", "unassisted-amendments"].includes(currrentApplicationScreen) && (
				<UserDelimitation
					makeDashboardTrigger={true}
					showVillage={currrentApplicationScreen === "removals"}
					showFilter
					returnedApplication={returnedApplication}
					onDelimitationChanged={setDelimitation}
				/>
			)}

			<div className="">
				<Toast ref={toast} />
			</div>
			{(currrentApplicationScreen === "unassisted-registration" || currrentApplicationScreen === "unassisted-amendments") && (
				<div>
					<Button label="Refresh" onClick={loadApplications} className="mt-4 p-button-primary" size="small" />
				</div>
			)}

			{currrentApplicationScreen !== "unassisted-registration" &&
				currrentApplicationScreen !== "unassisted-amendments" &&
				!currrentApplicationScreen === "corrections" && (
					<UserDelimitation
						makeDashboardTrigger={makeDashboardTrigger}
						showVillage={currrentApplicationScreen === "removals"}
						showFilter={true}
						onDelimitationChanged={(delimitation) => setDelimitation(delimitation)}
					/>
				)}
			<TabView
				key={activeTabIndex}
				activeIndex={activeTabIndex}
				onBeforeTabChange={onBeforeTabChange}
				className="mt-4"
				// onTabChange={(e) => {
				// 	setActiveTabIndex(e.index);
				// 	if (e.originalEvent.target.innerText === "Returned") {
				// 		// //Check when the returned tab is clicked
				// 		// console.log("Returned clicked");
				// 		pullUserInfo()
				// 		setReturnedApplication(true)
				// 	}
				// 	else{
				// 		setReturnedApplication(false)
				// 	}
				// }}
			>
				{drawApplicationsTab
					.filter((e) => e.screen === currrentApplicationScreen)
					.flatMap((tab) =>
						tab.menus.map((menuItem, index) => (
							<TabPanel key={index} header={menuItem} disabled={loading}>
								<ApplicationTable
									key={currrentApplicationScreen}
									loading={loading}
									setLoading={setLoading}
									query={query}
									header=""
									onShowApplication={onShowApplication}
									loadData={loadData}
									returnedApplication={returnedApplication}
									application={application}
								/>
							</TabPanel>
						))
					)}
			</TabView>

			{application && (currrentApplicationScreen === "unassisted-registration" || currrentApplicationScreen === "unassisted-amendments") && (
				<VerifyApplication
					applicationID={application?.applicationID}
					referenceNumber={application?.referenceNumber}
					applicationTypeID={application?.applicationTypeID}
					idNumber={application?.idNumber}
					visible={showApplication}
					onHide={onHideApplication}
					onSubmit={onSubmitApplication}
				/>
			)}

			{application && currrentApplicationScreen !== "unassisted-registration" && currrentApplicationScreen !== "unassisted-amendments" && (
				<>
					<ViewApplication
						applicationID={application?.applicationID}
						ApplicationInfo={application}
						referenceNumber={application?.referenceNumber}
						applicationTypeID={parseInt(application?.applicationTypeID)}
						idNumber={application?.idNumber}
						visible={showApplication}
						onHide={onHideApplication}
						onSubmit={onSubmitApplication}
						canTransact={canTransact}
					/>
				</>
			)}
		</Card>
	);
};
